import { Location } from "@angular/common";
import { DOCUMENT } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/router";
// service auto-scrolls element into view if url contains a ID fragment
// TODO: Can this be replaced by https://github.com/angular/angular/blob/13.3.x/packages/router/src/router_scroller.ts?
export let ScrollToElementService = /*#__PURE__*/(() => {
  class ScrollToElementService {
    constructor(location, router, document) {
      this.location = location;
      this.router = router;
      this.document = document;
      router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(e => {
        const tree = router.parseUrl(router.url);
        if (tree.fragment) {
          // timeout is required as el does not exist yet when the NavigationEnd event is fired
          setTimeout(() => {
            this.scrollToElement('#' + tree.fragment);
          }, 100);
        }
      });
    }
    /** NOTE: when using this method after a navigation, a small timeout is required to make it work correctly! */
    scrollToElement(el) {
      if (typeof el === 'string') {
        el = this.document.querySelector(el);
      }
      if (!el) return;
      el.scrollIntoView({
        behavior: "smooth" // try to do animated scroll (depends on browser settings)
        // block: "start", // scroll to start of element
        // inline: "nearest" // horizontal positioning. nearest is default
      });
    }
    static {
      this.ɵfac = function ScrollToElementService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ScrollToElementService)(i0.ɵɵinject(i1.Location), i0.ɵɵinject(i2.Router), i0.ɵɵinject(DOCUMENT));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: ScrollToElementService,
        factory: ScrollToElementService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ScrollToElementService;
})();